"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyRelationFieldLogic = void 0;
var dependency_relation_fieldtype_1 = require("./dependency-relation.fieldtype");
Object.defineProperty(exports, "DependencyRelationFieldLogic", { enumerable: true, get: function () { return dependency_relation_fieldtype_1.DependencyRelationFieldLogic; } });
